<template>
  <div class="modal fade" id="updateModal" tabindex="-1" role="dialog" aria-labelledby="updateModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Update Guest</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <input type="text" v-model="fullname" autocomplete="off" class="form-control mt-4" placeholder="Full Name" required>
            <input type="text" v-model="cluster" autocomplete="off" class="form-control mt-4" placeholder="Cluster" required>
            <input type="text" v-model="table" autocomplete="off" class="form-control mt-4" placeholder="Table" required>
        </div>
        <div class="modal-footer">
          <div>
              <div data-dismiss="modal"></div>
          </div>
          <div>
            <button type="button" class="btn btn-primary" @click="updateGuest" data-dismiss="modal">
                <i class="fas fa-check-square fa-lg"></i>
            </button>
            <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modalDelete">
                <i class="fas fa-trash fa-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal delete -->
    <div class="modal fade" id="modalDelete" tabindex="-1" role="dialog" aria-labelledby="modalDelete" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <p style="align:center">Are you sure to delete <br/> Guest : {{fullname}}</p>
        </div>
        <div class="modal-footer">
          <div>
            <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fas fa-ban fa-lg"></i>
            </button>
            <button type="button" class="btn btn-primary" @click="deleteGuest" data-dismiss="modal">
                <i class="fas fa-check-square fa-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import config from '@/config.js'
export default {
    props : ['guestId', 'getGuestData'],
    data : function() {
        return {
            fullname : '',
            cluster : '',
            table : ''
        }
    },
    watch :{
        guestId(){
            this.setData()
        }
    },
    methods : {
        setData(){
            axios({
                method : 'GET',
                url : `${config.port}/guests/showbyid/${this.guestId}`,
                headers : {
                    token : localStorage.getItem('token')
                }
            })
            .then(response => {
                this.fullname = response.data.name
                this.cluster = response.data.cluster
                this.table = response.data.table
            })
            .catch(err => {
                console.log(err)
            })
        },
        updateGuest(){
            axios({
                method : 'PUT',
                url : `${config.port}/guests/update/guest/${this.guestId}`,
                headers : {
                    token : localStorage.getItem('token')
                },
                data : {
                    name : this.fullname,
                    cluster : this.cluster,
                    table : this.table
                }
            })
            .then(response => {
                this.getGuestData()
            })
            .catch(err => {
                console.log(err)
            })
        },
        deleteGuest(){
          axios({
            method : 'DELETE',
            url : `${config.port}/guests/delete/${this.guestId}`,
            headers : {
              token : localStorage.getItem('token')
            }
          })
          .then(response => {
            console.log(response)
            this.getGuestData()
          })
          .catch(err => {
            console.log(err)
          })
        }
    }
}
</script>

<style>

</style>